module.exports = __webpack_public_path__ + "static/media/rating_img.3677a6c3.svg";